/* Built In Imports */
/* External Imports */
import { Box, Heading, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@msr/components/UI/StructuredTextContent';

/* Services */

/**
 * Renders Top Banner Simple Component
 * @param {Object} sectionContent - data from api
 * @returns Top Banner Simple Component
 */
const MsrTopicBanner = ({ sectionContent, pageData }) => {
  return (
    <Box
      backgroundImage={{
        md: sectionContent?.json?.bannerImage,
        base: sectionContent?.json?.bannerImage,
      }}
      backgroundSize={{ base: '100%', md: 'cover' }}
      backgroundPosition={{ base: 'top', md: 'center' }}
      backgroundColor="#000"
      backgroundRepeat="no-repeat"
      width="100%"
      position="relative"
      height={{ base: '300px' }}
      color="#FFF7E9"
      fontSize="40px"
      py={{ base: '50px', md: '0' }}
      px={{ base: '15px', lg: '10%' }}
    >
      <Box
        px="0"
        maxW="1140px"
        mx="auto"
        height="100%"
        display="flex"
        alignItems="left"
        flexDirection="column"
        justifyContent="center"
      >
        <Heading
          as="h1"
          mb="20px"
          fontSize={{ base: '26px', md: '40px' }}
          p={{ base: '11px 0', md: '16px 0' }}
          m="0"
        >
          <Image src="/assets/images/tag.png" mr="17px" />
          {pageData?.title}
        </Heading>

        {sectionContent?.json?.Description && (
          <Box fontSize="16px" fontFamily="FedraSansStd-book" maxW="586px">
            {sectionContent?.json?.Description}
          </Box>
        )}
        {pageData?.description && (
          <Box fontSize="16px" fontFamily="FedraSansStd-book" maxW="586px">
            {StructuredTextContent(pageData?.description)}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MsrTopicBanner;
